import {
  type DragEvent,
  type FunctionComponent,
  useEffect,
  useEffectEvent,
  useRef,
} from 'react';

import { isInsideRect } from 'utils';

import { addTouchDropListener } from '../../VideoCard';

import './style.scss';

type PropsT = {
  onDrop?: (e?: DragEvent<HTMLDivElement>) => void;
};

export const DropZone: FunctionComponent<PropsT> = ({ onDrop }) => {
  const dropEvent = useEffectEvent(onDrop ?? (() => undefined));

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const unsub = addTouchDropListener((x: number, y: number) => {
      const rect = ref.current?.getBoundingClientRect();
      if (isInsideRect([x, y], rect)) {
        dropEvent();
      }
    });
    return () => {
      unsub();
    };
  }, []);

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDrop={onDrop}
      ref={ref}
      styleName="container"
    >
      <div
        key="precise-drop-zone"
        styleName="content"
      >
        It will drop here
      </div>
    </div>
  );
};
